<template>
    <div>

        <div class="content-wrapper" v-if="!loadingComplete()">
            <section class="content">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">Chargement en cours</h3>
                        </div>
                        <div class="box-body">
                            Chargement du ranking
                        </div>
                        <div class="overlay">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="content-wrapper" v-if="loadingComplete()">

            <section class="content-header" >
                <h1>
                    Ranking
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li class="active"><a href="#">Ranking</a></li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="{ 'active': true }" >
                                    <a href="#ranking_tab_1"
                                       aria-controls="#ranking_tab_1"
                                       data-toggle="tab"
                                       aria-expanded="false">Ranking par compétiteurs</a>
                                </li>

                                <li :class="">
                                    <a href="#ranking_tab_2"
                                       aria-controls="#ranking_tab_2"
                                       data-toggle="tab"
                                       aria-expanded="false">Sélection entraînements fédéraux juniors</a>
                                </li>
                                <li :class="">
                                    <a href="#ranking_tab_3"
                                       aria-controls="#ranking_tab_3"
                                       data-toggle="tab"
                                       aria-expanded="false">Sélection stages fédéraux cadets</a>
                                </li>

                                <li :class="">
                                    <a href="#ranking_tab_4"
                                       aria-controls="#ranking_tab_4"
                                       data-toggle="tab"
                                       aria-expanded="false">Rankings publics</a>
                                </li>

<!--                                <li :class="{ 'active': formation_id==0 }">-->
<!--                                    <a href="#ranking_tab_3"-->
<!--                                       aria-controls="#ranking_tab_3"-->
<!--                                       data-toggle="tab"-->
<!--                                       aria-expanded="false">Listing des formations/examens</a>-->
<!--                                </li>-->

<!--                                <li class="pull-right">-->
<!--                                    <a @click.prevent="showModalNewFormation()">Ajouter une formation/un examen</a>-->
<!--                                </li>-->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div role="tabpanel" class="col-md-12 tab-pane"
                         :class="{ 'active': true }" id="ranking_tab_1">
                        <RankingCompetitors
                                :loadingTableCompetitors="loading"
                        ></RankingCompetitors>
                    </div>

                    <div role="tabpanel" class="col-md-12 tab-pane"
                         :class="{ 'active': false }" id="ranking_tab_2">
                        <SelectionEFJ
                                :loadingTableCompetitors="loading2"
                        ></SelectionEFJ>
                    </div>
                    <div role="tabpanel" class="col-md-12 tab-pane"
                         :class="{ 'active': false }" id="ranking_tab_3">
                        <SelectionSFC
                                :loadingTableCompetitors="loading3"
                        ></SelectionSFC>
                    </div>
                    <div role="tabpanel" class="col-md-12 tab-pane"
                         :class="{ 'active': false }" id="ranking_tab_4">
                        <RankingsPublic
                                :loadingTableCompetitors="loading3"
                        ></RankingsPublic>
                    </div>


                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import RankingCompetitors from './RankingCompetitors.vue'
    import SelectionEFJ from './SelectionEFJ.vue'
    import SelectionSFC from './SelectionSFC.vue'
    import RankingsPublic from './RankingPublic.vue'

    export default {
        data() {
            return {
                loading: false,
                loading2: false,
                loading3: false,
            }
        },
        props: {},
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            })
        },
        methods: {
            ...mapActions({
                setCriteresRanking:'setCriteresRanking'
            }),
            loadingComplete: function () {
                return true
            },
            loadCriteres: function () {
                this.loading = true
                this.$http.get(this.getRoute('Ranking.getCriteresRanking')).then((response) => {
                    this.setCriteresRanking(response.body)
                    this.loading = false
                }, (response) => {
                });
            },

        },
        beforeRouteUpdate(to, from, next) {
            this.loadCriteres()
            next()

        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.loadCriteres()
            })
        },
        watch: {},
        components: {
            RankingCompetitors,
            SelectionEFJ,
            RankingsPublic,
            SelectionSFC,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Ranking/AppRanking.vue